// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"d9f1337d","198":"1d8ec8f7","353":"20230857","787":"0e892a70","850":"46d326bf"}[chunkId] + ".chunk.js";
};